import css from './profile-picture.module.scss';

interface ProfilePictureProps {
	src: string,
}

export const ProfilePicture = ({ src }: ProfilePictureProps) => (
	<img className={css.picture} src={`/api/file/user/${src}`} alt="user" />
);
